import React from "react";
import { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Css/Feet.css";

const Fleet = () => {
  const vehicles = [
    {
      image:
        "https://cdn.pixabay.com/photo/2024/03/26/11/57/trucks-8656643_1280.jpg",
      type: "Heavy Duty Trucks",
      capacity: "Up to 25 Tons",
    },
    {
      image:
        "https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?auto=format&fit=crop&q=80",
      type: "Container Trucks",
      capacity: "20ft & 40ft Containers",
    },
    {
      image:
        "https://images.unsplash.com/photo-1519003722824-194d4455a60c?auto=format&fit=crop&q=80",
      type: "Refrigerated Vehicles",
      capacity: "Temperature Controlled",
    },
  ];

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 758);
    };

    // Initialize state
    handleResize();

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Cleanup the event listener
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const carouselSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 2,
    slidesToScroll: 1,

    centerPadding: "50px",
    responsive: [
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1,
          centerPadding: "10px",
        },
      },
    ],
  };

  return (
    <section id="fleet" className="py-20 FleetCOnt">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 animate-slide-in">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Fleet</h2>
          <p className="text-xl text-gray-600">
            Modern and well-maintained vehicles for all your transportation
            needs
          </p>
        </div>

        {isMobile ? (
          <div className="carousel">
            <Slider {...carouselSettings}>
              {vehicles.map((vehicle, index) => (
                <div
                  key={index}
                  className="relative overflow-hidden rounded-lg shadow-lg"
                >
                  <img
                    src={vehicle.image}
                    alt={vehicle.type}
                    className="w-full h-64 object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent">
                    <div className="absolute bottom-0 left-0 right-0 p-6">
                      <h3 className="text-white text-xl font-semibold mb-2">
                        {vehicle.type}
                      </h3>
                      <p className="text-gray-200">{vehicle.capacity}</p>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        ) : (
          <div className="grid grid-cols-3 GappClass">
            {vehicles.map((vehicle, index) => (
              <div
                key={index}
                className="group relative overflow-hidden rounded-lg shadow-lg cursor-pointer"
                style={{ animationDelay: `${index * 150}ms` }}
              >
                <img
                  src={vehicle.image}
                  alt={vehicle.type}
                  className="w-full h-64 object-cover transform transition-all duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-6 transform translate-y-6 group-hover:translate-y-0 transition-transform duration-300">
                    <h3 className="text-white text-xl font-semibold mb-2">
                      {vehicle.type}
                    </h3>
                    <p className="text-gray-200">{vehicle.capacity}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default Fleet;
